import { FC, useEffect } from "react";
import { FormProvider } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { useRecoilValue } from "recoil";

import { RASTER_LANDINGS } from "@ryde/assets-landings";
import { MessagesDisplayContainer, PhoneTemplate } from "@ryde/controls";
import {
  apiDataFetchingLandingAtom,
  landingMessagesAtom,
  WixLoginStepFormFieldsEnum,
} from "@ryde/utils-landings";

import { ContinueButton } from "../../widgets";
import { useStepLoginWix } from "./use-step-login.wix";

export const StepLoginWix: FC = () => {
  const { methods, handleLogin, isContinueCanBeApply } = useStepLoginWix();
  const [searchParams, setSearchParams] = useSearchParams();
  const landingMessages = useRecoilValue(landingMessagesAtom);
  const isApiLoading = useRecoilValue(apiDataFetchingLandingAtom);
  const { t } = useTranslation();

  useEffect(() => {
    if (searchParams) {
      setSearchParams("");
    }
  }, [searchParams, setSearchParams]);

  return (
    <FormProvider {...methods}>
      <div className="landing-title">
        {t("landing.login.title")}
        <br />
        {t("landing.login.subTitle")}
      </div>

      <div className="landing-form-field">
        <label htmlFor={WixLoginStepFormFieldsEnum.PhoneMobile}>
          {t("landing.formLabel.phone")}*
        </label>
        <PhoneTemplate
          uniqueAttrId={WixLoginStepFormFieldsEnum.PhoneMobile}
          name={WixLoginStepFormFieldsEnum.PhoneMobile}
          sx={{ size: "small" }}
          formAttributes={{ disablePhoneCallable: true }}
        />
      </div>

      <MessagesDisplayContainer
        serverMessages={landingMessages?.messages}
        type={landingMessages?.type}
      />

      <ContinueButton
        loading={isApiLoading}
        disabled={!isContinueCanBeApply}
        onClick={handleLogin}
      />

      <div className="landing-container-footer">
        <div className="landing-container-footer-logo">
          <img
            className="landing-logo__img"
            src={RASTER_LANDINGS.RideLogoPNG}
            alt="Ryde logo"
          />
        </div>
      </div>
    </FormProvider>
  );
};
